define('modules/QuickOrder/QuickOrder',[
    'jquery',
    'global/all',
    '../Cart/all',
    'plugins/jquery-ui.min'
], function ($, Roc, Cart) {
    'use strict';

    var isSlimWidget = false;
    var quickOrderUrl = "";
    var apiUrl = window.RocConfig.api.baseRocApiUrl;
    var viewModel = {
        shortListLimit: 15,
        qtyLimit: 20,
        items: [],
        order: []
    };

    var forms = {};
    var formTemplate = {
        Fields: [],
        Validate: true
    };

    var btns = {
        addToCart: '[data-roc-action="add-to-cart"]',
        showMoreFields: '[data-roc-action="show-more-fields"]',
        quickOrderToolLink: '[data-roc-action="link-to-quickorder"]'       
    };

    var limit = 30;

    // fixing isInteger issue on IE 
    Number.isInteger = Number.isInteger || function (value) {
        return typeof value === "number" &&
            isFinite(value) &&
            Math.floor(value) === value;
    };

    function buildViewModel() {
        viewModel.showMoreFields = false;
        if (isSlimWidget === true) {
            limit = 1;
        }
        for (var i = 1; i <= limit; i++) {
            viewModel.items.push({ index: i });
            forms['QuickOrder' + i] = _.cloneDeep(formTemplate);
            forms['QuickOrder' + i].Fields.push(
                {
                    Name: 'SkuSearch',
                    Field: '#sku-search-' + i,
                    Param: 'sku-search',
                    Type: 'Text',
                    Optional: true
                },
                {
                    Name: 'Sku',
                    Placeholder: 'Product #',
                    Field: '#sku' + i,
                    Param: 'sku',
                    Type: 'Text',
                    Optional: true
                },
                {
                    Name: 'Qty',
                    Placeholder: 'QTY',
                    Field: '#qty' + i,
                    Param: 'qty',
                    Type: 'Text',
                    Optional: false,
                    Validators: [
                        {
                            Type: 'Integer'
                        },
                        {
                            "Type": 'MinValue',
                            "Value": 1
                        }
                    ]
                },
                {
                    Name: 'DeliveryType',
                    Placeholder: 'DeliveryType #',
                    Field: '#quickOrderItem' + i + '-details .hdnDeliveryType',
                    Param: 'deliveryType',
                    Type: 'Text',
                    Optional: true
                },
                {
                    Name: 'PickupLocationId',
                    Placeholder: 'PickupLocationId #',
                    Field: '#quickOrderItem' + i + '-details .hdnPickupId',
                    Param: 'pickupLocationId',
                    Type: 'Text',
                    Optional: true
                }
            );
        }
    }

    function openDetailedProduct(itemIndex, product, label) {
        product.quantityMultiplier = Roc.Extensions.getAttributeValue(product, "multiplier");
        if (product.quantityMultiplier === null) {
            product.quantityMultiplier = 1;
        }

        // find element to update with the current product in the view model items, it should always exist because viewModel.items array is initialized with the same number of elements as the template
        var elementToUpdate = _.find(viewModel.items, { index: itemIndex });
        if (!elementToUpdate) {
            console.warn(
                'Unable to populate matching product in quick order tool because of invalid item index provided');
            return false;
        }

        elementToUpdate.item = {
            product: product,
            qty: product.quantityMultiplier
        };
        elementToUpdate.productName = label;
        elementToUpdate.sku = product.sku;
        if (product &&
            product.productPricing &&
            product.productPricing.customFields &&
            'quantityDiscounts' in product.productPricing.customFields) {
            elementToUpdate.quantityDiscounts = product.productPricing.customFields['quantityDiscounts'];
        }

        elementToUpdate.displayDescription = !isSlimWidget; // displaying short description only on full quick order
        load(itemIndex);
    }

    function clearDetailedProduct(id) {
        $('#quickOrderItem' + id + '-details').html("");
    }

    function showOrderFieldEvt() {
        $(document).on('click', btns.showMoreFields, function (e) {
            e.preventDefault(); //make sure page is not reloaded after click
            viewModel.showMoreFields = !viewModel.showMoreFields;
            $('.additional').toggleClass('in');
            $('.additional').find('.sku').val("");
            $('.additional.details').html("");
            $(".addOrderField").html(($(".addOrderField").text() === "ADD MORE ITEMS TO YOUR ORDERS") ?
                "HIDE THE ADDITIONAL ITEMS" :
                "ADD MORE ITEMS TO YOUR ORDERS");
        });
    };

    function quickOrderToolLinkEvt() {
        $(document).on('click', btns.quickOrderToolLink, function (e) {
            e.preventDefault(); //make sure page is not reloaded after click
            window.location = viewModel.quickOrderUrl;
        });
    };

    function validateAndCollectData() {
        var result = {
            isValid: true,
            products: []
        }
        $.each(forms, function (index, form) {
            var skuField = _.find(form.Fields, { Name: 'SkuSearch' });
            form.Validate = skuField && $(skuField.Field).val() !== "";
        });

        if (!Roc.Validation.validate(forms, false)) {
            result.isValid = false;
            $('[data-roc-error="true"]').addClass('hidden');
        }

        if (!result.isValid) {
            Roc.UI.displayErrorPopup('There looks to be a problem with your current quantity. Please be sure to enter the correct quantity value and try again.');
            return result;
        }

        $.each(forms, function (index, form) {
            if (form.Validate) {
                var data = Roc.Forms.getFormValues(form);
                result.products.push(data);
            }
        });

        if (result.products.length === 0) {
            Roc.UI.info("You need to add product", "Information");
            result.isValid = false;
        }

        return result;
    }

    function changeQuantityEvt() {
        $(document).off('change', '.qtyTextBox');
        $(document).on('change', '.qtyTextBox', function () {
            var $that = $(this);
            if ($that.data().hasOwnProperty("index")) {
                $.each(viewModel.items, function (index, value) {
                    if (value.index === $that.data('index')) {
                        value.item.qty = Number($that.val());
                        if (value.item.product && value.item.product.quantityMultiplier) {
                            value.item.qty = Math.ceil(value.item.qty / value.item.product.quantityMultiplier) * value.item.product.quantityMultiplier;
                            $that.val(value.item.qty);
                        }
                    }
                });
            }
        });
    }

    function removeItemEvt() {
        $(document)
            .off('click', '.removeCartItem')
            .on('click', '.removeCartItem', function () {

                var quickOrderItemIndex = Number($(this).data('index'));
                if (!Number.isInteger(quickOrderItemIndex)) {
                    return;
                }

                Roc.UI.confirm({
                    "title": 'Delete Confirmation',
                    "message": 'Are you sure you want to delete this item?',
                    "buttons": {
                        "Yes": {
                            "class": 'btn btnAction confirm',
                            "autoClose": true,
                            "action": function () {
                                var quickOrderItemToResetIndexInItems = _.findIndex(viewModel.items, function (obj) { return obj.index === quickOrderItemIndex });
                                if (quickOrderItemToResetIndexInItems > -1) {
                                    viewModel.items.splice(quickOrderItemToResetIndexInItems, 1);
                                    viewModel.items.push({ index: (viewModel.items.length + 1) });

                                    for (var i = 0; i < viewModel.items.length; i++) {
                                        viewModel.items[i].index = (i + 1);
                                    }
                                    load(quickOrderItemIndex);
                                }
                            }
                        },
                        "No": {
                            "class": 'btn',
                            "action": function () { }
                        }
                    }
                });
            });
    }

    function submitFormEvt() {
        $(document).on('click', btns.addToCart, function () {
            Cart.CartSummary.init({ cartFlyoutMode: 'Quick Order' });

            var data = validateAndCollectData();
            if (!data.isValid) {
                return false;
            }

            var viewModel = {
                CurrentOrderId: '{orderId}',
                Products: data.products
            };

            Roc.UI.block("#quickOrderWrapper");
            $.proxyRequest({
                url: '/api/quickorder/additemstocart',
                data: JSON.stringify(viewModel),
                type: "POST",
                dataType: 'json',
                contentType: 'application/json',
                complete: function (resp) {
                    if (resp.status === 200 && resp.responseJSON !== null) {
                        var messages = "";
                        var isAnySuccess = false;
                        _.each(resp.responseJSON.addCartItemsResponse, function (item) {
                            if (item.success === false) {
                                messages += "<p>" + item.message + "</p>";
                            } else {
                                isAnySuccess = true;
                            }
                        });

                        if (isAnySuccess) {
                            Roc.EventManager.notify(Roc.Events.cart.ADD_ITEM, resp);
                        }

                        if (messages !== "") {
                            Roc.UI.confirm({
                                "title": 'Information',
                                "message": messages,
                                "buttons": {
                                    "Back": {
                                        "class": 'btn',
                                        "action": function () { }
                                    },
                                    "Go to Cart": {
                                        "class": 'btn',
                                        "action": function () {
                                            window.location.href = '/cart';
                                        }
                                    }
                                }
                            });
                            Roc.UI.unblock("#quickOrderWrapper");
                            return false;
                        }

                        window.location.href = '/cart';

                    } else if (resp.responseJSON !== null && resp.responseJSON.message !== null) {
                        Roc.UI.displayErrorPopup(resp.responseJSON.message);
                        Roc.UI.unblock("#quickOrderWrapper");

                    } else {
                        Roc.UI.displayErrorPopup('There was an error while trying to add to cart!');
                        Roc.UI.unblock("#quickOrderWrapper");
                    }
                }
            });
            return false;
        });
    }

    function getSelectedProduct(item, id) {
        Roc.UI.block();
        $.ajax({
            url: apiUrl + '/api/quickorder/getproductbysku/',
            data: { "sku": item.key },
            success: function (response) {
                var product = response.product;
                product.priceQuantity = response.productDetails;
                product.deliveryOptions = response.productDeliveryOptions;
                product.productAvailability = response.productAvailability;
                // var hasRestrictions = response.productDetails.restrictions || false;
                openDetailedProduct(id, product, item.label);
            }
        }).always(function () {
            Roc.UI.unblock();
        });
    }

    function createLabel(item) {
        var label = '';
        if (item.catalogId || item.brandName) {
            label += 'Catalog # ';

            if (item.brandName) {
                label += item.brandName + ' ';
            }

            if (item.catalogId) {
                label += item.catalogId + ' ';
            }

            label += ": ";
        }

        if (item.customerPartNumber) {
            label += 'Your Part # ' + item.customerPartNumber + ': ';
        }

        if (item.sku) {
            label += 'SKU # ' + item.sku;
        }
        return label;
    }

    function getProducts(keyword, renderResponse) {
        var url = apiUrl + '/api/quickorder/search?keyword=' + encodeURIComponent(keyword) + '&pagesize=10';
        var itemList = [];

        if (keyword !== '') {
            $.ajax({
                type: 'GET',
                url: url,
                async: true,
                contentType: 'application/json; charset=utf-8'
            }).success(function (items) {
                items = _.filter(items, function (item) {
                    return !_.some(viewModel.items, function (value) { return value.sku === item.sku && value.item });
                });

                itemList = items.map(function (item) {
                    return { key: item.sku, label: createLabel(item) };
                });

                renderResponse(itemList);
            }).error(function () {
            });
        }
        return itemList;
    }

    function bindEvents() {
        showOrderFieldEvt();
        quickOrderToolLinkEvt();
        changeQuantityEvt();
        removeItemEvt();
        submitFormEvt();
    }

    function lookUpUpdate() {
        $(".sku").autocomplete({
            minLength: 0,
            search: function (event, ui) {
                var target = $(event.target);
                if (target.val() === "") {
                    clearDetailedProduct(target.data("index"));
                }
            },
            response: function (event, ui) {
            },
            source: function (request, response) {
                return getProducts(request.term, response);
            },
            change: function (event, ui) {
                var databefore = $(event.target).data("productname");
                var input = $(event.target);
                if (input.val() !== databefore) {
                    var item = _.find(viewModel.items, { 'productName': databefore });
                    if (!item) {
                        return;
                    }

                    $.each(viewModel.items, function (index, value) {
                        if (!value.item) {
                            delete viewModel.items[index];
                        }
                    });

                    var temp = [];
                    var index = 0;
                    for (var i in viewModel.items) {
                        var itemValue = viewModel.items[i];
                        itemValue.index = index + 1;
                        temp[index++] = itemValue;
                    }
                    viewModel.items = temp;
                    for (index = 0; index < limit; index++) {
                        var value = viewModel.items[index];
                        if (!value) {
                            viewModel.items.push({ index: index + 1 });
                        }
                    }

                    load();
                }
            },
            autoFocus: true,
            select: function (e, ui) {
                var itemIndex = $(this).data('index');
                getSelectedProduct(ui.item, itemIndex);
            }
        });
    };

    function load(itemIndex) {
        viewModel.isSlimWidget = isSlimWidget;
        viewModel.quickOrderUrl = quickOrderUrl;

        viewModel.hideButton = _.some(viewModel.items, function (item) {
            return item && item.item && item.item.product && !item.item.product.priceQuantity;
        });

        Roc.UI.template('quickOrderList-Tmp',
            viewModel
        ).then(function (renderedTemplate) {
            $('#quickOrderWrapper').html(renderedTemplate);
            lookUpUpdate();
            if (itemIndex) {
                var quickOrderItemContainer = $('#quickOrderItem' + itemIndex);
                var currentQuickOrderItemQuantityTextBox = $('.qtyTextBox[data-index='+itemIndex+']');
                Roc.UI.scrollTo(quickOrderItemContainer, -60);
                $(currentQuickOrderItemQuantityTextBox).focus();
				$(currentQuickOrderItemQuantityTextBox).select();
            }
            Roc.Extensions.initMoreLinks();
            Roc.UI.unblock("#quickOrderWrapper");
        });
    }

    window.addEventListener("load", function () {
        setTimeout(checkQOSlim, 3000);
    }, false);

    function checkQOSlim() {
        if (isSlimWidget === true) {
            $('.ui-autocomplete').addClass('qo-slim');
        }
    };

    function init(options) {
        if (options) {
            isSlimWidget = options.isSlimWidget;
            quickOrderUrl = options.quickOrderUrl;
        }

        buildViewModel();
        Roc.UI.block("#quickOrderWrapper");
        load();
        bindEvents();
    };

    var QuickOrder = {
        init: init,
        order: viewModel.Order
    };

    return QuickOrder;
});
